import { ITrainersData, ITrainersTool } from '@/types/trainers';
import InstructionsIcon from '@/components/ui/icons/trainers/InstructionsIcon';
import BackButton from './BackButton';
import Markdown from './shared/Markdown';
import ReviewsCount from './ReviewsCount';

interface Props {
  elementRef: React.RefObject<HTMLDivElement>;
  data?: ITrainersData;
  tool?: ITrainersTool;
  name?: string;
  description?: string;
  location?: string;
}

const TrainerHeader: React.FC<Props> = ({
  tool,
  data,
  name,
  description = '',
  location,
  elementRef,
}) => {
  const instructions = tool?.args?.instructions;
  return (
    <div className="flex w-full flex-col" ref={elementRef}>
      <div className="flex flex-col items-center justify-center border-b border-neutral-700 bg-neutral-800 p-2 pl-1 md:flex-row md:justify-between md:px-4 md:pl-1">
        <div className="flex w-full items-center justify-center md:justify-start">
          <BackButton />
          <h1 className="my-1 mr-4 text-xl font-bold text-neutral-0 md:text-2xl">
            {name}
          </h1>
          <h3 className="text-xl font-normal text-neutral-0 md:text-2xl">
            {location}
          </h3>
        </div>
        <div className="flex shrink-0 items-center justify-center md:justify-end">
          <ReviewsCount data={data} />
        </div>
      </div>
      <div className="relative flex min-h-[40px] items-center justify-center border-b border-neutral-700 bg-neutral-800 p-2 md:px-4">
        <h2 className="text-center text-base font-normal md:text-lg">
          <Markdown text={description} />
        </h2>
        {instructions && (
          <a
            href={instructions}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute right-4 top-1/2 flex -translate-y-1/2 cursor-pointer">
            <InstructionsIcon className="size-5 fill-neutral-0" />
          </a>
        )}
      </div>
    </div>
  );
};

export default TrainerHeader;
